/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientAttributeType from './patient-attribute-type';
import PatientAttributeTypeDetail from './patient-attribute-type-detail';
import PatientAttributeTypeUpdate from './patient-attribute-type-update';
import PatientAttributeTypeDeleteDialog from './patient-attribute-type-delete-dialog';

const PatientAttributeTypeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientAttributeType />} />
    <Route path="new" element={<PatientAttributeTypeUpdate />} />
    <Route path=":id">
      <Route index element={<PatientAttributeTypeDetail />} />
      <Route path="edit" element={<PatientAttributeTypeUpdate />} />
      <Route path="delete" element={<PatientAttributeTypeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientAttributeTypeRoutes;
